/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _StreamDeletionRequestCalloutContainer_viewer$ref: unique symbol;
export type StreamDeletionRequestCalloutContainer_viewer$ref = typeof _StreamDeletionRequestCalloutContainer_viewer$ref;
export type StreamDeletionRequestCalloutContainer_viewer = {
    readonly scheduledDeletionDate: string | null;
    readonly " $refType": StreamDeletionRequestCalloutContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StreamDeletionRequestCalloutContainer_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "scheduledDeletionDate",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '30e6a790ebb6a322efb594b8a18811f4';
export default node;
